// extracted by mini-css-extract-plugin
export default {"container":"ConfirmAccountPage_container__sKSR6","lockup":"ConfirmAccountPage_lockup__CptO4"};